import { Components } from '@mui/material/styles';

import { colors } from 'theme/colors';

const outlinedInput: Components['MuiOutlinedInput'] = {
  styleOverrides: {
    root: {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.border.light,
        borderWidth: '1px',
      },
    },
  },
};

export default outlinedInput;
